import Vue from 'vue'
import Router from 'vue-router'

import config from 'SrcConfig'

// Layout
const Layout = () => import('@/components/layout')
// const DefaultLayout = () => import('@/Layout/DefaultLayout')

// Views
const Dashboard = () => import('@/components/dashboard')
const Login = () => import('@/components/account/login')
const Register = () => import('@/components/account/Register')
const ForgotPassword = () => import('@/components/account/forgotPassword')
const Page404 = () => import('@/components/shared/Page404')

import account from './account'
import transports from './transports'
import stocks from './stocks'

Vue.use(Router)

const options = {
  mode: 'history',
  linkActiveClass: 'open active',
  // scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'root',
      path: '/',
      redirect: config.homeUrl,
      meta: { label: 'Home' },
      component: Layout,
      children: [
        {
          name: 'login',
          path: 'login',
          component: Login,
          meta: { public: true }
        },
        {
          name: 'Register',
          path: 'register',
          component: Register,
          meta: { public: true }
        },
        {
          name: 'ForgotPassword',
          path: 'forgot-password',
          component: ForgotPassword,
          meta: { public: true }
        },
        account,
        transports,
        stocks,
        {
          name: 'dashboard',
          path: 'dashboard',
          meta: {label: 'Dashboard', auth: true},
          component: Dashboard
        }
      ]
    },
    {
      name: 'catch-all',
      path: '*',
      component: Page404
    }
  ]
}

  
export default new Router(options)
